<script>
  import FilingStatusSelect from "../../lib/FilingStatusSelect/FilingStatusSelect.svelte";
  import Input from "../../lib/Input.svelte";
  import Slider from "../../lib/Slider.svelte";
  import StateSelect from "../../lib/StateSelect/StateSelect.svelte";
  import Select from "../../lib/Select.svelte";
  import { HoldingPeriod } from "../../common/constants";
  import { calculateFederalTaxAmount, calculateStateTaxAmount } from "../calculator";
  import ResultPanel from "../ResultPanel.svelte";
  import { safeDivide } from "../../common/utils";

  const lengthOfOwnershipOptions = [
    { name: "1 Year Or Less", value: HoldingPeriod.ShortTerm },
    { name: "Greater Than 1 Year", value: HoldingPeriod.LongTerm }
  ];

  $: form = {
    investment: 0,
    buy_price: 0,
    sell_price: 0,
    investment_fee: 0,
    exit_fee: 0,
    annual_income: 0,
    length_of_ownership: HoldingPeriod.ShortTerm,
    location: "california",
    filling_status: "single"
  };

  // the percent the value of the coin changed
  $: percentChange = safeDivide(form.sell_price - form.buy_price, form.buy_price);

  // the amount of money the gained/lossed in the trade
  $: saleEarnings = (Number(form.investment) * percentChange) - form.investment_fee - form.exit_fee;

  $: federalTaxAmount = calculateFederalTaxAmount({
    gainAmount: saleEarnings,
    annualIncome: form.annual_income,
    fillingStatus: form.filling_status,
    holdingPeriod: form.length_of_ownership,
  });

  $: stateTaxAmount = calculateStateTaxAmount({
    gainAmount: saleEarnings,
    annualIncome: form.annual_income,
    fillingStatus: form.filling_status,
    state: form.location,
  });
</script>

<div class="grid grid-cols-2 md:grid-cols-3 gap-12 mt-10 border rounded bg-white p-8">
  <div>
    <Input bind:value={form.investment} label="Investment" infoText="The total amount invested in a specific cryptocurrency" />
    <Slider bind:value={form.investment} />
  </div>
  <div>
    <Input bind:value={form.buy_price} label="Buy Price" infoText="The price of the cryptocurrency at the time of purchase" />
    <Slider bind:value={form.buy_price} />
  </div>
  <div>
    <Input bind:value={form.sell_price} label="Sell Price" infoText="The price of the cryptocurrency at the time of sale" />
    <Slider bind:value={form.sell_price} />
  </div>
  <div>
    <Input bind:value={form.investment_fee} label="Investment Fee" infoText="The fee incurred when purchasing a specific cryptocurrency" />
    <Slider bind:value={form.investment_fee} max={1000} />
  </div>
  <div>
    <Input bind:value={form.exit_fee} label="Exit Fee" infoText="The fee incurred when selling a specific cryptocurrency" />
    <Slider bind:value={form.exit_fee} max={1000} />
  </div>
  <div>
    <Input bind:value={form.annual_income} label="Annual Income" />
    <Slider bind:value={form.annual_income} />
  </div>
  <div>
    <Select bind:value={form.length_of_ownership} label="Length of Ownership" options={lengthOfOwnershipOptions} />
  </div>
  <div>
    <StateSelect bind:value={form.location} />
  </div>
  <div>
    <FilingStatusSelect bind:value={form.filling_status} />
  </div>
</div>
<ResultPanel totalTaxableAmount={saleEarnings} federalResult={federalTaxAmount} stateResult={stateTaxAmount} />